// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Mob_Navbar{
    position: absolute;
    top: 0;
    width: 100%;
    color: var(--black);
    z-index: 3;
    text-align: center;
}


.Mob_Navbar_right{
    position: absolute;
    padding:2rem 0rem;
    height: 90vh;
    top:10vh;
    background-color: var(--white);
    width: 100vw;
  animation: slide_left 0.5s ease-out;
  display: flex;
  justify-content:flex-start;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  overflow-y: scroll;
  /* min-width: max-content; */

  
}

@keyframes slide_left {
    0%{
        width: 0%;
    }
    100%{
        width: 100%;
    }
}
.Mob_Navbar_right >*{
    font-size: 1.2rem;
    color: var(--black);
    padding-bottom:0.4rem ;
    border-bottom: 0.6px solid rgba(0,0,0,0.2) ;
    font-weight: 400;
    letter-spacing: 0.1rem;
    line-height: 1;
}
.hidee>*{
    display: none;
}
.hidden_animation {
    position: absolute;
    background-color:  var(--white);
    width: 0vw;
    padding: 4rem 0rem;
    height: 70vh;
    animation: slide_right 0.5s linear;
    top:10vh;
}
.hidden_animation> *{
   display: none;
}
@keyframes slide_right {
    0%{
        width: 100%;
        border: 0;
        z-index: 2;
    }
    100%{
        width: 0%;
        }
    
}

.burger{
    position: absolute;
    top:4.2vh;
    right:5rem;
    display: flex;
    min-width: max-content;
    flex-direction: column;
    gap: 0.4rem;
    justify-content: center;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px;
}
.burger-dashboard{
    top:11vh !important;
    left: 1rem;
    right: 100%;
    z-index: 0 !important;
}

.burger-dashboard>div{
    background-color: var(--black) !important;
    background: var(--black) !important;   
}
.burger>div{

    width: 25px;
    height:6px;
    background-color: var(--primary_color);
    background: var(--primary_color);
}

.burger>:nth-child(1){
    animation: burger1 0.5s linear;
    transform: rotate(0deg);
}
@keyframes burger1 {
    0%{
        transform: rotate(45deg);
    }
    100%{
    transform: rotate(0deg);


    }
 }

 .burger>:nth-child(2){
    animation: burger2 0.5s linear;
    transform: rotate(0deg);
}
@keyframes burger2 {
    0%{
        transform: rotate(135deg);
    }
    100%{
    transform: rotate(0deg);


    }
 }

.cross>:nth-child(1){
    animation: cross1 0.5s linear;
    transform: rotate(45deg);
}
 @keyframes cross1 {
    0%{
        transform: rotate(0deg);
    }
    100%{
    transform: rotate(45deg);


    }
 }
.cross>:nth-child(2){
    animation: cross2 0.5s linear;
    transform: rotate(135deg);

    
}
@keyframes cross2 {
    0%{
    transform: rotate(0deg);
    }
    100%{
    transform: rotate(135deg);
    }
 }
@media only screen and (min-width: 1025px){
    .Mob_Navbar{
        display: none;
    }
}
@media screen and (max-width: 380px){
    .burger>div {
        width: 24px;

    }
}`, "",{"version":3,"sources":["webpack://./src/Components/MobileNav/MobileNav.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,kBAAkB;AACtB;;;AAGA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,QAAQ;IACR,8BAA8B;IAC9B,YAAY;EACd,mCAAmC;EACnC,aAAa;EACb,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4BAA4B;;;AAG9B;;AAEA;IACI;QACI,SAAS;IACb;IACA;QACI,WAAW;IACf;AACJ;AACA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,2CAA2C;IAC3C,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;AAClB;AACA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,kCAAkC;IAClC,QAAQ;AACZ;AACA;GACG,aAAa;AAChB;AACA;IACI;QACI,WAAW;QACX,SAAS;QACT,UAAU;IACd;IACA;QACI,SAAS;QACT;;AAER;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,WAAW;IACX,uBAAuB;IACvB,8FAA8F;AAClG;AACA;IACI,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,yCAAyC;IACzC,mCAAmC;AACvC;AACA;;IAEI,WAAW;IACX,UAAU;IACV,sCAAsC;IACtC,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;AACA;IACI;QACI,wBAAwB;IAC5B;IACA;IACA,uBAAuB;;;IAGvB;CACH;;CAEA;IACG,8BAA8B;IAC9B,uBAAuB;AAC3B;AACA;IACI;QACI,yBAAyB;IAC7B;IACA;IACA,uBAAuB;;;IAGvB;CACH;;AAED;IACI,6BAA6B;IAC7B,wBAAwB;AAC5B;CACC;IACG;QACI,uBAAuB;IAC3B;IACA;IACA,wBAAwB;;;IAGxB;CACH;AACD;IACI,6BAA6B;IAC7B,yBAAyB;;;AAG7B;AACA;IACI;IACA,uBAAuB;IACvB;IACA;IACA,yBAAyB;IACzB;CACH;AACD;IACI;QACI,aAAa;IACjB;AACJ;AACA;IACI;QACI,WAAW;;IAEf;AACJ","sourcesContent":[".Mob_Navbar{\n    position: absolute;\n    top: 0;\n    width: 100%;\n    color: var(--black);\n    z-index: 3;\n    text-align: center;\n}\n\n\n.Mob_Navbar_right{\n    position: absolute;\n    padding:2rem 0rem;\n    height: 90vh;\n    top:10vh;\n    background-color: var(--white);\n    width: 100vw;\n  animation: slide_left 0.5s ease-out;\n  display: flex;\n  justify-content:flex-start;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  overflow-y: scroll;\n  /* min-width: max-content; */\n\n  \n}\n\n@keyframes slide_left {\n    0%{\n        width: 0%;\n    }\n    100%{\n        width: 100%;\n    }\n}\n.Mob_Navbar_right >*{\n    font-size: 1.2rem;\n    color: var(--black);\n    padding-bottom:0.4rem ;\n    border-bottom: 0.6px solid rgba(0,0,0,0.2) ;\n    font-weight: 400;\n    letter-spacing: 0.1rem;\n    line-height: 1;\n}\n.hidee>*{\n    display: none;\n}\n.hidden_animation {\n    position: absolute;\n    background-color:  var(--white);\n    width: 0vw;\n    padding: 4rem 0rem;\n    height: 70vh;\n    animation: slide_right 0.5s linear;\n    top:10vh;\n}\n.hidden_animation> *{\n   display: none;\n}\n@keyframes slide_right {\n    0%{\n        width: 100%;\n        border: 0;\n        z-index: 2;\n    }\n    100%{\n        width: 0%;\n        }\n    \n}\n\n.burger{\n    position: absolute;\n    top:4.2vh;\n    right:5rem;\n    display: flex;\n    min-width: max-content;\n    flex-direction: column;\n    gap: 0.4rem;\n    justify-content: center;\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px;\n}\n.burger-dashboard{\n    top:11vh !important;\n    left: 1rem;\n    right: 100%;\n    z-index: 0 !important;\n}\n\n.burger-dashboard>div{\n    background-color: var(--black) !important;\n    background: var(--black) !important;   \n}\n.burger>div{\n\n    width: 25px;\n    height:6px;\n    background-color: var(--primary_color);\n    background: var(--primary_color);\n}\n\n.burger>:nth-child(1){\n    animation: burger1 0.5s linear;\n    transform: rotate(0deg);\n}\n@keyframes burger1 {\n    0%{\n        transform: rotate(45deg);\n    }\n    100%{\n    transform: rotate(0deg);\n\n\n    }\n }\n\n .burger>:nth-child(2){\n    animation: burger2 0.5s linear;\n    transform: rotate(0deg);\n}\n@keyframes burger2 {\n    0%{\n        transform: rotate(135deg);\n    }\n    100%{\n    transform: rotate(0deg);\n\n\n    }\n }\n\n.cross>:nth-child(1){\n    animation: cross1 0.5s linear;\n    transform: rotate(45deg);\n}\n @keyframes cross1 {\n    0%{\n        transform: rotate(0deg);\n    }\n    100%{\n    transform: rotate(45deg);\n\n\n    }\n }\n.cross>:nth-child(2){\n    animation: cross2 0.5s linear;\n    transform: rotate(135deg);\n\n    \n}\n@keyframes cross2 {\n    0%{\n    transform: rotate(0deg);\n    }\n    100%{\n    transform: rotate(135deg);\n    }\n }\n@media only screen and (min-width: 1025px){\n    .Mob_Navbar{\n        display: none;\n    }\n}\n@media screen and (max-width: 380px){\n    .burger>div {\n        width: 24px;\n\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
